'use strict';

var navigationModule = angular.module('t2g.common.directives.navigation', []);

module.exports = navigationModule;

var allowedRoles = {
  admin: ['admin'],
  manager: ['admin', 'manager'],
  employee: ['admin', 'manager', 'employee'],
  viewer: ['admin', 'manager', 'employee', 'viewer'],
};

navigationModule.directive('navigation', function($document, $compile, navigationSettings) {
  return {
    restrict: 'E',
    template:
      '' +
      '<div class="navbar-offcanvas" off-canvas>' +
      '   <a href="https://www.sanasearch.ch/de/mein-profil/"><div class="navbar-logo"></div></a>' +
      '   <ul class="navbar-offcanvas-nav">' +
      '       <li data-ng-repeat="topItem in navigation" data-ng-class="{\'nav-item-notification\': topItem.notification, \'nav-item-highlight\': topItem.highlight}">' +
      '           <navigation-item href="#" role="button">' +
      '               <i class="{{::topItem.icon}}"></i>{{::topItem.label}}' +
      '           </navigation-item>' +
      '       </li>' +
      '   </ul>' +
      '</div>',
    controller: function($scope, $element, $interpolate) {
      function enrichNavigationItem(item) {
        if (/{{.*}}/.test(item.label)) {
          item.label = $interpolate(item.label)($scope);
        }

        if (item.notification) {
          item.notification = $scope.$eval(item.notification);
        }

        return item;
      }

      _.map(navigationSettings, function(navigationSettingsItem) {
        navigationSettingsItem = enrichNavigationItem(navigationSettingsItem);

        if (navigationSettingsItem.subMenu) {
          _.map(navigationSettingsItem.subMenu, enrichNavigationItem);
        }

        return navigationSettingsItem;
      });

      $scope.navigation = navigationSettings;

      $scope.checkRole = function(minimumRole) {
        var role = _.get($scope.user, 'role');
        var authorized = false;

        if (role && allowedRoles[minimumRole].indexOf(role) !== -1) {
          authorized = true;
        }

        return authorized;
      };
    },
    link: function($scope, $element) {},
  };
});

navigationModule.directive('navigationItem', function($state, $transitions) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<a ng-transclude></a>',
    link: function($scope, $element) {
      var subMenuContainer;
      var subMenuList;
      var bookingsBadge;

      if (
        ($scope.topItem.role && !$scope.checkRole($scope.topItem.role)) ||
        ($scope.topItem.show && !$scope.$eval($scope.topItem.show))
      ) {
        $element.remove();
        return;
      }

      if ($state.current.name.indexOf($scope.topItem.state) > -1) {
        $element[0].classList.add('active');
      }

      if ($scope.topItem.state === 'private.main.booking') {
        // generate badge for not processed bookings count
        bookingsBadge = document.createElement('span');
        bookingsBadge.setAttribute('class', 'badge');
        $element[0].parentNode.appendChild(bookingsBadge);

        // update number in the badge on updateBookingsBadge event
        $scope.$on('updateBookingsBadge', function(event, notProcessedBookings) {
          bookingsBadge.innerText = notProcessedBookings > 9 ? '9+' : notProcessedBookings || '';
        });
      }

      if ($scope.topItem.subMenu) {
        $element.addClass('has-submenu');
        $element[0].href = '#';

        // generate sub menu
        subMenuContainer = document.createElement('div');
        subMenuContainer.setAttribute('class', 'navbar-submenu-wrapper');
        subMenuList = document.createElement('ul');

        _.forEach($scope.topItem.subMenu, function(subMenuItem) {
          if (subMenuItem.role && !$scope.checkRole(subMenuItem.role)) {
            return;
          }

          var subMenuListItem = document.createElement('li');
          var subMenuItemLink = document.createElement('a');
          var subMenuItemText = document.createTextNode(subMenuItem.label);

          if (subMenuItem.notification) {
            subMenuListItem.classList.add('nav-item-notification');
          }

          if ($state.current.name.indexOf(subMenuItem.state) > -1) {
            $element[0].classList.add('active');
          }

          subMenuItemLink.href = $state.href(subMenuItem.state, subMenuItem.stateParams, {
            inherit: false,
          });
          subMenuItemLink.appendChild(subMenuItemText);
          subMenuListItem.appendChild(subMenuItemLink);
          subMenuList.appendChild(subMenuListItem);
        });

        subMenuContainer.appendChild(subMenuList);
        $element[0].parentNode.appendChild(subMenuContainer);
      } else if ($scope.topItem.state) {
        if ($scope.topItem.state !== 'private.main.calendar') {
          $element[0].href = $state.href($scope.topItem.state, $scope.topItem.stateParams, {
            inherit: false,
          });
        } else {
          $element[0].href = '#/private/main/calendar';
        }
      }

      _.forEach($scope.topItem.attributes, function(value, key) {
        $element[0].setAttribute(key, value);
      });

      $element.on('click', function(event) {
        if ($('.navbar').is(':visible') || !_.get($scope, 'topItem.subMenu.length')) {
          return;
        }

        if ($(subMenuContainer).hasClass('in')) {
          $(subMenuContainer).removeClass('in');
          $('body').removeClass('nav-open');
        } else {
          $('.in').removeClass('in');
          $(subMenuContainer).addClass('in');
          $('body').addClass('nav-open');
        }

        event.stopPropagation();

        if ($scope.topItem.subMenu) {
          event.preventDefault();
        }
      });

      $transitions.onSuccess({}, function(transition) {
        var toState = transition.to().name || '';
        var activeItemIndex = _.findIndex($scope.topItem.subMenu, function(subMenuItem) {
          return toState.indexOf(subMenuItem.state) > -1;
        });

        if (activeItemIndex > -1 || toState.indexOf($scope.topItem.state) > -1) {
          $element[0].classList.add('active');
        } else {
          $element[0].classList.remove('active');
        }
      });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/directives/navigationDirective.js